import styled, { css } from 'styled-components';
import { InformationWarning } from './components/information-warning';

export const Container = styled.div`
  width: 100%;
  padding: 0 16px;
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  margin: 0 auto;
  font-size: 14px;
  margin-top: 10px;
  ${({ theme }) => css`
    color: ${theme.grey.dark};
    background-color: ${theme.white};
    border: 1px solid ${theme.grey.lighter};
  `}
`;

export const WarningContainer = styled(InformationWarning)`
  margin-top: 20px;
`;

export const ViewUI = styled.div`
  display: grid;
  text-align: ${props => (props.align ? props.align : 'left')};
`;

export const CellUI = styled.div`
  display: flex;
`;

export const LaunchWrapper = styled.div``;

export const LaunchText = styled.p`
  font-size: 12px;
  padding-top: 16px;
`;

export const ModalLink = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: transparent;
  width: 100%;
  border: 0;
  padding-top: 16px;
  margin-top: 16px;
  color: ${({ theme }) => theme.grey.dark};
  text-decoration: underline;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
  cursor: pointer;

  &:focus,
  &:active {
    border: 0;
    outline: 0;
  }

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
